import { createFileRoute } from '@tanstack/react-router'

import PaymentReturn from '@/screens/account/components/payment/PaymentReturn'

/**
 * eSewa's failure URL. It brings no usable params, so the attempt is the
 * tab's stash — and it is still confirmed, not taken as failed on the
 * redirect's word (`PaymentReturn` says why). No `validateSearch`, for the
 * reason `PaymentReturnScreen` gives.
 */
export const Route = createFileRoute('/_app/payment/failed')({
  component: PaymentFailedScreen,
})

function PaymentFailedScreen() {
  return <PaymentReturn landing="failed" />
}
